import { Service } from '@/services/api';
import { BinderReviewListResponse, BinderReviewQuery } from '@/types/BinderReview';

class BinderReviewService extends Service {
  // Every binder extraction on the account, internal and external, in one stable order.
  // It backs the review list page, the policies-page pill and the review page's Back/Next
  // sequence, and it is what an account-scoped review page checks a result against before
  // opening it -- the prompt-result endpoints themselves are account-agnostic.
  //
  // Passing page and size asks for one page; without them the whole matching set comes
  // back, which is what Back/Next needs to know where the sequence ends.
  async list(accountId: string | number, query: BinderReviewQuery = {}): Promise<BinderReviewListResponse> {
    const params: Record<string, string> = {};
    if (query.status) {
      params.status = query.status;
    }
    if (query.source) {
      params.source = query.source;
    }
    if (query.search?.trim()) {
      params.search = query.search.trim();
    }
    if (query.size != null) {
      params.size = String(query.size);
      params.page = String(query.page ?? 0);
    }

    return await this.get<BinderReviewListResponse>(
      `/v2/accounts/${accountId}/binder-reviews`,
      Object.keys(params).length > 0 ? params : undefined,
    ).then(this.handleResponse);
  }
}

export const binderReviewService = new BinderReviewService();
